import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FormInstanceId } from 'api/models';
import { EllipsisMiddle } from 'components/atoms/middle-ellipsis';
import { getProjectFormByInstanceUrl } from 'utils/urls';
import { useGetAnswersFromFormInstance } from './get-answers-length';

const ResponseCount = styled.span`
  font-size: var(--font-size-sm);
  color: var(--cool-gray-40);
  margin-left: var(--spacing-03);
`;

const LENGTH_OF_CHARACTERS = 8;

export const ListItem: FC<{
  projectId: number;
  formInstanceId: number;
  taskName: string;
}> = ({ projectId, formInstanceId, taskName }) => {
  const arrOfWords = taskName.trim().split(' ');
  const lastWordCount = arrOfWords[arrOfWords.length - 1].length;
  const formResponse = useGetAnswersFromFormInstance({ formInstanceId });

  return (
    <Link
      to={getProjectFormByInstanceUrl(
        FormInstanceId(projectId, formInstanceId),
      )}
    >
      <EllipsisMiddle
        suffixCount={
          lastWordCount < LENGTH_OF_CHARACTERS
            ? lastWordCount
            : LENGTH_OF_CHARACTERS
        }
        tooltip={false}
        width="165px"
      >
        {taskName}
      </EllipsisMiddle>
      <ResponseCount>{`(${formResponse?.answers.length ?? 0})`}</ResponseCount>
    </Link>
  );
};
